import { useState } from 'react';

import { inject, observer } from 'mobx-react';

// import ZoneListH5 from '@widget/market/TradeList/ListH5';
import { SpotTradeAPI } from '@api/spotTrade';
import CollectEmpty from '@components/CollectEmpty';
import { TabPane, Tabs } from '@element/index';
import helper from '@utils/helper';
import I18n from '@utils/i18n';
import { handleZoneList } from '@widget/market/TradeList/utils';

// import ListH5 from '../TradeList/ListH5';
import List from '../TradeList/List';

import styles from './index.module.css';

const OptionaTab = (props) => {
  const {
    tradeStore: {
      favoriteObject: { zones = [] }
    },
    marketStore,
    showEdit,
    showCollection,
    type,
    className,
    tradePairDataSource,
    tabBarExtraContent,
    setDrawerVisible = () => {}
  } = props;
  const [zonesMarketList, setZonesMarketList] = useState([]);
  const [loading, setLoading] = useState(false);

  const tabChange = async (activeKey) => {
    if (activeKey !== '0') {
      setLoading(true);
      const response = await SpotTradeAPI.getZoneDetail({
        key: activeKey,
        currency: 'USDT'
      })
      if (response && response.success && response.obj) {
        const dataList = handleZoneList({
          dataList: response.obj?.tickerList ?? [],
          marketStore
        });
        setZonesMarketList(dataList);
        setLoading(false);
        return;
      }
      helper.handleErrorMsg(response?.msgKey);
    }
  };

  return (
    <Tabs
      type={type === 'drawer' ? 'marketTab' : 'marketTabCoin'}
      className={className}
      onChange={tabChange}
      tabBarExtraContent={tabBarExtraContent}
    >
      <TabPane tab={I18n.t('symbol_list')} key="0">
        <List
          type={type}
          dataSource={tradePairDataSource}
          marketStore={marketStore}
          showCollection={showCollection}
          isEdit={showEdit}
          emptyText={<CollectEmpty className={styles.empty} />}
          setDrawerVisible={setDrawerVisible}
        />
      </TabPane>
      {zones.map((zone) => (
        <TabPane tab={zone.categoryName} key={zone.categoryKey}>
          <List
            page="ZONES_PAGE"
            type={type}
            loading={loading}
            dataSource={zonesMarketList}
            marketStore={marketStore}
            setDrawerVisible={setDrawerVisible}
          />
        </TabPane>
      ))}
    </Tabs>
  );
};

export default inject((rootStore) => ({
  marketStore: rootStore.store.marketStore,
  tradeStore: rootStore.store.tradeStore
}))(observer(OptionaTab));
